/**
 * Compare the token issuing policy with a specific policy name
 * @param {object} idTokenClaims - Object containining token claims
 * @param {string} policyToCompare - ID/Name of the policy as expressed in the Azure portal
 * @returns {boolean}
 */
export const compareIssuingPolicy = (
    idTokenClaims: { [key: string]: string | number } | undefined,
    policyToCompare: string
): boolean => {
    const policy = policyToCompare.toLowerCase();
    if (idTokenClaims) {
        const tfpMatches = idTokenClaims['tfp']?.toString().toLowerCase() === policy;
        const acrMatches = idTokenClaims['acr']?.toString().toLowerCase() === policy;
        return tfpMatches || acrMatches;
    }
    return false;
};
